import {
    Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle
} from 'shared/components/ui/card';
import {
    Label
} from 'shared/components/ui/label';
import {
    Button
} from 'shared/components/ui/button';
import {
    convertUnixTimestampToDate
} from 'shared/utils/timeUtils';
import {
    httpRequest
} from 'shared/utils/httpsRequest';
import {
    addTrailingZero
} from 'shared/utils/numbersUtils';
import {
    convertToTitleCase
} from 'shared/utils/stringUtils';

export default function SubscriptionDetails({
    isManage,
    subscription
}) {
    const endDate = convertUnixTimestampToDate(subscription.currentPeriodEnd);

    const handleBillingPortal = async () => {
        try {
            const response = await httpRequest.post('/db/subscriptions/create-billing-portal-session', {
                customerId: subscription.customerId,
                returnUrl: window.location.href,
            });

            window.location.href = response.data.url;
        } catch (error) {
            console.error('Failed to create billing portal session:', error.message);
        }
    };

    return (
        <div className='flex flex-grow flex-col'>
            <Card className="w-full p-6">
                <CardHeader className='p-0'>
                    <CardTitle> Current Plan </CardTitle>
                    {subscription?.cancelAtPeriodEnd && (
                        <CardDescription className='text-destructive'>
                            This subscription is cancelled and will end at {convertUnixTimestampToDate(subscription?.cancelAt)}
                        </CardDescription>
                    )}
                </CardHeader>
                <CardContent className='mt-6 p-0'>
                    {/* Plan headline */}
                    <div className='mb-6 flex flex-wrap items-end justify-between gap-2 rounded-lg border bg-muted/40 p-4'>
                        <div>
                            <p className='text-lg font-semibold'>{subscription.items.data.price.product.name}</p>
                            <p className='mt-1 max-w-prose text-sm text-muted-foreground'>{subscription.items.data.price.product.description}</p>
                        </div>
                        <div className='text-right'>
                            <span className='text-2xl font-bold'>{subscription.items.data.price.unitAmount / 100}</span>
                            <span className='ml-1 text-sm font-medium text-muted-foreground'>{subscription.items.data.price.currency.toUpperCase()}</span>
                        </div>
                    </div>

                    <dl className='divide-y divide-border'>
                        <Row label='Subscription ID' value={subscription.subscriptionId} mono />
                        {subscription.customer?.name && (
                            <Row label='Customer name' value={subscription.customer.name} />
                        )}
                        {subscription.customer?.description && (
                            <Row label='Customer description' value={subscription.customer.description} wrap />
                        )}
                        <Row label='Created' value={subscription.created.split('T')[0]} />
                        <Row label='Current period' value={endDate} />
                        {subscription.paymentInfo && (
                            <>
                                <Row label='Payment method' value={`${convertToTitleCase(subscription.paymentInfo.brand)} •••• ${subscription.paymentInfo.last4}`} />
                                <Row label='Card expiry' value={`${addTrailingZero(subscription.paymentInfo.expMonth)}/${subscription.paymentInfo.expYear}`} />
                            </>
                        )}
                    </dl>
                </CardContent>
                {isManage && (
                    <CardFooter className='mt-6 flex justify-end p-0'>
                        <Button onClick={handleBillingPortal}> Manage Plan </Button>
                    </CardFooter>
                )}
            </Card>
        </div>
    );
}

function Row({
    label, value, mono, wrap
}) {
    return (
        <div className={`flex justify-between gap-4 py-2.5 ${wrap ? 'items-start' : 'items-center'}`}>
            <Label className='shrink-0 text-gray-500'>{label}</Label>
            <span className={`text-right font-medium ${wrap ? 'max-w-[70%] whitespace-normal break-words' : ''} ${mono ? 'font-mono text-xs text-muted-foreground' : ''}`}>{value}</span>
        </div>
    );
}
